import { Grid } from "@mui/material";
import { format } from "date-fns";
import React, { Fragment } from "react";
import Pagination from "../Global/Pagination";
import { ResCard } from "../Global/ResCard";
import { collection, getDocs, orderBy, query } from "firebase/firestore";
import { db } from "../../firebase";

export const ArticleCard = () => {
  const [articles, setArticles] = React.useState([]);

  const getArticles = async () => {
    try {
      const q = query(collection(db, "articles"), orderBy("createdAt", "desc"));
      const snap = await getDocs(q);
      setArticles(
        snap.docs.map((d) => ({
          _id: d.id,
          ...d.data(),
          createdAt: d.data().createdAt?.toDate() || new Date(),
        })),
      );
    } catch (err) {
      console.error(err.message);
    }
  };

  React.useEffect(() => {
    getArticles();
  }, []);

  const [currentPage, setCurrentPage] = React.useState(1);
  const [postsPerPage] = React.useState(6);

  const lastPostIndex = currentPage * postsPerPage;
  const firstPostIndex = lastPostIndex - postsPerPage;
  const currentPosts = articles.slice(firstPostIndex, lastPostIndex);

  return (
    <Fragment>
      <Grid container spacing={3} justifyContent="center" className="px-5 md:px-4 lg:px-10 py-10">
        {currentPosts.map((article, index) => (
          <Grid item={true} xs={12} sm={6} md={4} lg={4} key={index}>
            <ResCard
              image={article.imgSrc}
              title={article.title}
              btnName="Read More"
              date={format(new Date(article.createdAt), "d, MMMM yyyy")}
              path={`/articles/view/${article.slug}`}
              comment={article.commentCount}
              iconText={article.author}
              authorImg={article.authorImg}
              phrase={article.phrase}
            />
          </Grid>
        ))}
      </Grid>
      <div className="mx-auto">
        <Pagination
          totalPosts={articles.length}
          postsPerPage={postsPerPage}
          setCurrentPage={setCurrentPage}
          currentPage={currentPage}
        />
      </div>
    </Fragment>
  );
};
